import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface CloseTreasuryBondsPayload {
  uuid: string;
  closedAt: string;
}

export const useCloseTreasuryBonds = (
  options?: UseMutationOptions<any, Error, CloseTreasuryBondsPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["closeTreasuryBonds"],
    mutationFn: async ({ uuid, closedAt }: CloseTreasuryBondsPayload) => {
      return axiosInstance
        .post(`/investments/${uuid}/close`, { closedAt })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Zamykanie obligacji skarbowych...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "close-treasury-bonds",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Obligacje skarbowe zostały zamknięte.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "close-treasury-bonds",
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas zamykania obligacji skarbowych.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "close-treasury-bonds",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
